import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";
import Login from "./components/login";
import Dashboard from "./components/dashboard";
import HealthAcnt from "./components/healthacnt";
import Header from "./components/Header";
import ConditionalHeader from "./components/ConditionalHeader";
import Profile from "./components/Profile";
import Abhalogin from "./components/Abhalogin";
import ForgotAbha from "./components/Forgotabha";
import Vendordashboard from "./components/Vendordashboard";
import ViewAppointment from "./components/Viewappointment";
import Uploadabha from "./components/Uploadabha";
import Viewallcustomers from "./components/Viewallcustomers";
import Viewcustomerrecord from "./components/Viewcustomerrecord";
import ViewDocuments from "./components/viewdocuments";
import ViewDoctor from "./components/Viewdoctor";
import PatientProfile from "./components/PatientProfile";
import Consent from "./components/consent";
import RecordDetailsPage from "./components/RecordDetailsPage";
import { PrimeReactProvider, PrimeReactContext } from "primereact/api";
import AbhaRecords from "./components/abhaRecords";
import SignUpForm from "./components/SignUpForm";
import ProfileComparison from "./components/ProfileComparison";

const App = () => {
  return (
    <PrimeReactProvider>
      <Router>
        <div className="App">
          <ConditionalHeader /> {/* Conditionally render the Header */}
          {/* <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/healthacnt" element={<HealthAcnt />} />
        </Routes> */}
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard" />} />
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/healthacnt" element={<HealthAcnt />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/patient-profile" element={<PatientProfile />} />
            <Route path="/abhalogin" element={<Abhalogin />} />
            <Route path="/forgot-abha" element={<ForgotAbha />} />
            <Route path="/hospital-dashboard" element={<Vendordashboard />} />
            <Route path="/ViewAppointment" element={<ViewAppointment />} />
            <Route path="/Uploadabha" element={<Uploadabha />} />
            <Route path="/Viewall" element={<Viewallcustomers />} />
            <Route path="/Viewrecord" element={<Viewcustomerrecord />} />
            <Route path="/Viewdocuments" element={<ViewDocuments />} />
            <Route path="/Viewdoctor" element={<ViewDoctor />} />
            <Route path="/consent" element={<Consent />} />
            <Route path="/record-details" element={<RecordDetailsPage />} />
            <Route path="/abhaRecords" element={<AbhaRecords />} />
            <Route path="/patientSignup" element={<SignUpForm />} />
            <Route path="/profile-comparison" element={<ProfileComparison />} />
          </Routes>
        </div>
      </Router>
    </PrimeReactProvider>
  );
};

export default App;
